// @flow
import type {ILocalesTransformers, ITranslate} from '../utils/locales';
import {useContext} from 'react';
import {LocalesContext} from '../utils/locales';

export const useTranslate = (): ITranslate => {
    const {translate}: ILocalesTransformers = useContext(LocalesContext);
    return translate;
};
